import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1 min-w-0 flex flex-col overflow-hidden" }
const _hoisted_2 = { class: "h-16 flex items-center px-6 border-b border-border shrink-0 bg-background" }
const _hoisted_3 = { class: "flex-1 overflow-auto p-6 lg:p-8" }
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-6" }
const _hoisted_5 = { class: "md:w-56 shrink-0" }
const _hoisted_6 = { class: "rounded-xl border bg-card text-card-foreground shadow" }
const _hoisted_7 = { class: "p-2" }
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = {
  key: 0,
  class: "rounded-xl border bg-card text-card-foreground shadow"
}
const _hoisted_10 = { class: "p-6 pt-0 space-y-5" }
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" }
const _hoisted_12 = { class: "space-y-1.5" }
const _hoisted_13 = { class: "space-y-1.5" }
const _hoisted_14 = { class: "space-y-1.5" }
const _hoisted_15 = { class: "space-y-1.5" }
const _hoisted_16 = { class: "space-y-1.5" }
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = ["type"]
const _hoisted_19 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "h-4 w-4",
  "aria-hidden": "true"
}
const _hoisted_20 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "h-4 w-4",
  "aria-hidden": "true"
}
const _hoisted_21 = { class: "space-y-1.5" }
const _hoisted_22 = { class: "flex justify-end pt-2" }
const _hoisted_23 = {
  key: 1,
  class: "rounded-xl border bg-card text-card-foreground shadow"
}
const _hoisted_24 = { class: "p-6 pt-0 space-y-5" }
const _hoisted_25 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_26 = { class: "space-y-1.5" }
const _hoisted_27 = { class: "space-y-1.5" }
const _hoisted_28 = { class: "space-y-1.5" }
const _hoisted_29 = { class: "space-y-1.5 md:col-span-2" }
const _hoisted_30 = { class: "flex justify-end pt-2" }
const _hoisted_31 = {
  key: 2,
  class: "rounded-xl border bg-card text-card-foreground shadow"
}
const _hoisted_32 = { class: "p-6 pt-0" }
const _hoisted_33 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-4 py-8 text-center"
}
const _hoisted_34 = {
  key: 1,
  class: "flex flex-col sm:flex-row sm:items-end gap-4"
}
const _hoisted_35 = { class: "space-y-1.5 flex-1 max-w-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_RotateLoader = _resolveComponent("RotateLoader")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, {
    "no-sidebar": false,
    "no-search": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "lg:hidden mr-3 p-2 rounded-md hover:bg-accent text-foreground transition-colors",
            "aria-label": "Open menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              class: "h-5 w-5",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", { d: "M4 5h16" }),
              _createElementVNode("path", { d: "M4 12h16" }),
              _createElementVNode("path", { d: "M4 19h16" })
            ], -1)
          ]))]),
          _cache[18] || (_cache[18] = _createElementVNode("h1", { class: "!text-xl !font-bold text-foreground" }, "Settings", -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.navButtonClass(1)),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 1))
                  }, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      class: "h-4 w-4 shrink-0",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" }),
                      _createElementVNode("rect", {
                        x: "2",
                        y: "4",
                        width: "20",
                        height: "16",
                        rx: "2"
                      })
                    ], -1),
                    _createElementVNode("span", { class: "text-left" }, "Email Configuration", -1)
                  ]))], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.navButtonClass(2)),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 2))
                  }, [...(_cache[20] || (_cache[20] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      class: "h-4 w-4 shrink-0",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", { d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z" }),
                      _createElementVNode("circle", {
                        cx: "13.5",
                        cy: "6.5",
                        r: ".5",
                        fill: "currentColor"
                      }),
                      _createElementVNode("circle", {
                        cx: "17.5",
                        cy: "10.5",
                        r: ".5",
                        fill: "currentColor"
                      }),
                      _createElementVNode("circle", {
                        cx: "6.5",
                        cy: "12.5",
                        r: ".5",
                        fill: "currentColor"
                      }),
                      _createElementVNode("circle", {
                        cx: "8.5",
                        cy: "7.5",
                        r: ".5",
                        fill: "currentColor"
                      })
                    ], -1),
                    _createElementVNode("span", { class: "text-left" }, "Customize Email Design", -1)
                  ]))], 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(_ctx.navButtonClass(3)),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 3))
                  }, [...(_cache[21] || (_cache[21] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      class: "h-4 w-4 shrink-0",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", { d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z" }),
                      _createElementVNode("path", { d: "M6 12h16" })
                    ], -1),
                    _createElementVNode("span", { class: "text-left" }, "Send Test Email", -1)
                  ]))], 2)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_ctx.activeTab === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "flex flex-col space-y-1.5 p-6" }, [
                      _createElementVNode("div", { class: "font-semibold tracking-tight text-lg" }, "Email Configuration"),
                      _createElementVNode("p", { class: "text-sm text-muted-foreground" }, "Configure SMTP settings for sending partner emails.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[22] || (_cache[22] = _createElementVNode("label", {
                            class: "text-sm font-medium leading-none",
                            for: "host"
                          }, [
                            _createTextVNode(" Email Host "),
                            _createElementVNode("span", { class: "text-destructive" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "host",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formValues.mail_host) = $event)),
                            class: _normalizeClass(_ctx.inputClass),
                            placeholder: "smtp.gmail.com",
                            type: "text"
                          }, null, 2), [
                            [_vModelText, _ctx.formValues.mail_host]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", {
                            class: "text-sm font-medium leading-none",
                            for: "port"
                          }, [
                            _createTextVNode(" Email Port "),
                            _createElementVNode("span", { class: "text-destructive" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "port",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formValues.mail_port) = $event)),
                            class: _normalizeClass(_ctx.inputClass),
                            placeholder: "587",
                            type: "text"
                          }, null, 2), [
                            [_vModelText, _ctx.formValues.mail_port]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _cache[24] || (_cache[24] = _createElementVNode("label", {
                            class: "text-sm font-medium leading-none",
                            for: "fromEmail"
                          }, [
                            _createTextVNode(" From Email Address "),
                            _createElementVNode("span", { class: "text-destructive" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "fromEmail",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formValues.mail_from_address) = $event)),
                            class: _normalizeClass(_ctx.inputClass),
                            placeholder: "no-reply@company.com",
                            type: "email"
                          }, null, 2), [
                            [_vModelText, _ctx.formValues.mail_from_address]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[25] || (_cache[25] = _createElementVNode("label", {
                            class: "text-sm font-medium leading-none",
                            for: "username"
                          }, [
                            _createTextVNode(" Email Username "),
                            _createElementVNode("span", { class: "text-destructive" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "username",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formValues.mail_username) = $event)),
                            class: _normalizeClass(_ctx.inputClass),
                            placeholder: "username",
                            type: "text"
                          }, null, 2), [
                            [_vModelText, _ctx.formValues.mail_username]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _cache[28] || (_cache[28] = _createElementVNode("label", {
                            class: "text-sm font-medium leading-none",
                            for: "password"
                          }, [
                            _createTextVNode(" Email Password "),
                            _createElementVNode("span", { class: "text-destructive" }, "*")
                          ], -1)),
                          _createElementVNode("div", _hoisted_17, [
                            _withDirectives(_createElementVNode("input", {
                              id: "password",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formValues.mail_password) = $event)),
                              class: _normalizeClass(`${_ctx.inputClass} pr-10`),
                              placeholder: "••••••••",
                              type: _ctx.isEmailPasswordVisible ? 'text' : 'password'
                            }, null, 10, _hoisted_18), [
                              [_vModelDynamic, _ctx.formValues.mail_password]
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordViewMode && _ctx.togglePasswordViewMode(...args)))
                            }, [
                              (!_ctx.isEmailPasswordVisible)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[26] || (_cache[26] = [
                                    _createElementVNode("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" }, null, -1),
                                    _createElementVNode("circle", {
                                      cx: "12",
                                      cy: "12",
                                      r: "3"
                                    }, null, -1)
                                  ]))]))
                                : (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[27] || (_cache[27] = [
                                    _createElementVNode("path", { d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" }, null, -1),
                                    _createElementVNode("path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242" }, null, -1),
                                    _createElementVNode("path", { d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" }, null, -1),
                                    _createElementVNode("path", { d: "m2 2 20 20" }, null, -1)
                                  ]))]))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _cache[29] || (_cache[29] = _createElementVNode("label", {
                            class: "text-sm font-medium leading-none",
                            for: "encryption"
                          }, [
                            _createTextVNode(" Email Encryption "),
                            _createElementVNode("span", { class: "text-destructive" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "encryption",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formValues.mail_encryption) = $event)),
                            class: _normalizeClass(_ctx.inputClass),
                            placeholder: "Enter email encryption",
                            type: "text"
                          }, null, 2), [
                            [_vModelText, _ctx.formValues.mail_encryption]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_BaseButton, { onClick: _ctx.saveEmailConfiguration }, {
                          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                            _createTextVNode("Save email configuration", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeTab === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "flex flex-col space-y-1.5 p-6" }, [
                      _createElementVNode("div", { class: "font-semibold tracking-tight text-lg" }, "Customize Email Design"),
                      _createElementVNode("p", { class: "text-sm text-muted-foreground" }, "Customize how partner emails look and feel.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _cache[32] || (_cache[32] = _createElementVNode("label", {
                            class: "text-sm font-medium leading-none",
                            for: "fromName"
                          }, "Email From Name", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "fromName",
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formValues.mail_from_name) = $event)),
                            class: _normalizeClass(_ctx.inputClass),
                            placeholder: "Enter email from name",
                            type: "text"
                          }, null, 2), [
                            [_vModelText, _ctx.formValues.mail_from_name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _cache[33] || (_cache[33] = _createElementVNode("label", {
                            class: "text-sm font-medium leading-none",
                            for: "headline"
                          }, "Email Headline", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "headline",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formValues.mail_headline) = $event)),
                            class: _normalizeClass(_ctx.inputClass),
                            placeholder: "Enter email headline",
                            type: "text"
                          }, null, 2), [
                            [_vModelText, _ctx.formValues.mail_headline]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _cache[34] || (_cache[34] = _createElementVNode("label", {
                            class: "text-sm font-medium leading-none",
                            for: "footer"
                          }, "Email Footer", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "footer",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formValues.mail_footer) = $event)),
                            class: _normalizeClass(_ctx.inputClass),
                            placeholder: "Enter email footer",
                            type: "text"
                          }, null, 2), [
                            [_vModelText, _ctx.formValues.mail_footer]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _cache[35] || (_cache[35] = _createElementVNode("label", {
                            class: "text-sm font-medium leading-none",
                            for: "signature"
                          }, "Email Signature", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            id: "signature",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formValues.mail_signature) = $event)),
                            class: "flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
                            placeholder: "Enter email signature",
                            rows: "3"
                          }, null, 512), [
                            [_vModelText, _ctx.formValues.mail_signature]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_BaseButton, { onClick: _ctx.saveCustomizedEmailDesign }, {
                          default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                            _createTextVNode("Save email design", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeTab === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "flex flex-col space-y-1.5 p-6" }, [
                      _createElementVNode("div", { class: "font-semibold tracking-tight text-lg" }, "Send Test Email"),
                      _createElementVNode("p", { class: "text-sm text-muted-foreground" }, "Verify your SMTP configuration by sending a test email.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_32, [
                      (!_ctx.isEmailConfigurationCompleted)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _cache[39] || (_cache[39] = _createElementVNode("p", { class: "text-sm text-muted-foreground" }, "Setup email configuration first.", -1)),
                            _createVNode(_component_BaseButton, {
                              disabled: _ctx.isRequestingTestEmail,
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.activeTab = 1))
                            }, {
                              default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                _createTextVNode(" Take me there ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["disabled"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _cache[40] || (_cache[40] = _createElementVNode("label", {
                                class: "text-sm font-medium leading-none",
                                for: "testEmail"
                              }, "Test email address", -1)),
                              _withDirectives(_createElementVNode("input", {
                                id: "testEmail",
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.testEmail) = $event)),
                                class: _normalizeClass(_ctx.inputClass),
                                placeholder: "Enter test email",
                                type: "email"
                              }, null, 2), [
                                [_vModelText, _ctx.testEmail]
                              ])
                            ]),
                            _createVNode(_component_BaseButton, {
                              disabled: _ctx.isRequestingTestEmail,
                              onClick: _ctx.testEmailConfig
                            }, {
                              default: _withCtx(() => [
                                (_ctx.isRequestingTestEmail)
                                  ? (_openBlock(), _createBlock(_component_RotateLoader, { key: 0 }))
                                  : _createCommentVNode("", true),
                                _cache[41] || (_cache[41] = _createTextVNode(" Send test request ", -1))
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ]))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}